// 我的订单 订单地址
<template>
  <div class="order">
    <slidepage :navData="navDatafa" @indexChanged="indexChanged" :navStyle="navStyle" :designatedLocation="number">
      <template v-for="(item,index) in navDatafa" v-slot:[slide+index]>
				<div :key="index" class="slideSign" >
          <myOrderList :status="item.status" :contentId="item.id"></myOrderList>
				</div>
			</template>
    </slidepage>
  </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
import slidepage from "../slidePage.vue"
import myOrderList from "./myOrderList"
export default {
  components:{
    slidepage,
    myOrderList
  },
  data(){
    return{
      slide:'slide',
      nowBlock:0,
      navDatafa:[
        {
          title:"全部",
          id:'one',
          status:""
        },
        {
          title:"待兑换",
          id:'two',
          status:"10"
        },
        {
          title:"待提货",
          id:'Three',
          status:"20"
      }],
      navStyle:{background:"#fafafa",textAlign:"center"},
      number:0 //指定索颖
    }
  },
  created(){
      var that=this;
      // 屏蔽当前信息
      this.setupWebViewJavascriptBridge(function(bridge){ //锁定到指定位置
          bridge.registerHandler("showOrder", function(data,responseCallback){
            that.number=Number(data);
            var responseData = {"Javascript Says": "Right back atcha!快递费拉萨"};
            responseCallback(responseData);
          });
      });
  },
  methods:{
    indexChanged(index){
      this.nowBlock=index;
    }
  }
}
</script>

<style scoped>
  .slideSign{
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>